import * as React from "react";
import {
  Card,
  Box,
  Stack,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import {
  useGetList,
  SimpleList,
  useGetIdentity,
  usePermissions,
} from "react-admin";

import { Avatar } from "../suppliercontacts/Avatar";
import { Contact } from "../types";
import { Link } from "react-router-dom";
import { getSituacaoCellSx } from "../skurankings/situacaoStyles";
import LaunchIcon from "@mui/icons-material/Launch";

type RankingItem = Contact & {
  prod_xprod?: string;
  nome_marca?: string;
  nome_comprador?: string;
  situacao?: string | null;
  curva?: number;
};

export const HotContacts = () => {
  const { identity } = useGetIdentity();
  const { permissions } = usePermissions();

  const {
    data: contactData,
    total: contactTotal,
    isPending: contactsLoading,
  } = useGetList<RankingItem>(
    "skurankings",
    {
      pagination: { page: 1, perPage: 10 },
      sort: { field: "dos", order: "ASC" },
      filter: {
        // status: "hot",
        cod_comprador: permissions !== "admin" ? identity?.id : null,
        curva_minima: 10,
      },
    },
    { enabled: Number.isInteger(identity?.id) },
  );

  return (
    <Stack>
      <Box display="flex" alignItems="center" mb={1}>
        <Box mr={1} display="flex">
          <LeaderboardIcon color="disabled" fontSize="medium" />
        </Box>
        <Typography variant="h5" color="textSecondary">
          Ranking de DOS
        </Typography>
        <Tooltip title="Ver Todos">
          <IconButton
            size="small"
            sx={{
              color: "text.secondary",
              ml: "auto",
            }}
            component={Link}
            to="/skurankings"
          >
            <LaunchIcon fontSize="inherit" color="primary" />
          </IconButton>
        </Tooltip>
      </Box>
      <Card
        sx={{
          "& .MuiCardContent-root": {
            padding: "16px !important",
          },
        }}
      >
        <SimpleList<RankingItem>
          linkType="show"
          data={contactData}
          total={contactTotal}
          isPending={contactsLoading}
          resource="suppliercontacts"
          primaryText={(contact) => `${contact.prod_xprod}`}
          secondaryText={(contact) => {
            const situacao = contact.situacao;
            return (
              <>
                {contact.nome_marca} • {"Curva: " + contact.curva} •{" "}
                {contact.nome_comprador} •{" "}
                <Box
                  component="span"
                  sx={{
                    display: "inline-block",
                    px: 0.75,
                    py: 0.125,
                    borderRadius: 0.5,
                    lineHeight: 1.4,
                    ...getSituacaoCellSx(situacao),
                  }}
                >
                  {situacao ?? ""}
                </Box>
              </>
            );
          }}
          leftAvatar={(contact) => <Avatar record={contact} />}
          dense
          empty={
            <Box p={2}>
              <Typography variant="body2" gutterBottom>
                Contatos relacionados aos seus clientes aparecerão aqui.
              </Typography>
            </Box>
          }
        />
      </Card>
    </Stack>
  );
};
